/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTimeEntryTypeRequest
 */
export interface UpdateTimeEntryTypeRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTimeEntryTypeRequest
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryTypeRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimeEntryTypeRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryTypeRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimeEntryTypeRequest
     */
    useEmployeePayRate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimeEntryTypeRequest
     */
    useAppointmentPayRate?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateTimeEntryTypeRequest
     */
    percentage?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateTimeEntryTypeRequest
     */
    hourlyPayRate?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTimeEntryTypeRequest
     */
    roles?: Array<string> | null;
}

/**
 * Check if a given object implements the UpdateTimeEntryTypeRequest interface.
 */
export function instanceOfUpdateTimeEntryTypeRequest(value: object): value is UpdateTimeEntryTypeRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpdateTimeEntryTypeRequestFromJSON(json: any): UpdateTimeEntryTypeRequest {
    return UpdateTimeEntryTypeRequestFromJSONTyped(json, false);
}

export function UpdateTimeEntryTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimeEntryTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'isActive': json['isActive'],
        'description': json['description'] == null ? undefined : json['description'],
        'useEmployeePayRate': json['useEmployeePayRate'] == null ? undefined : json['useEmployeePayRate'],
        'useAppointmentPayRate': json['useAppointmentPayRate'] == null ? undefined : json['useAppointmentPayRate'],
        'percentage': json['percentage'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['percentage']),
        'hourlyPayRate': json['hourlyPayRate'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['hourlyPayRate']),
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function UpdateTimeEntryTypeRequestToJSON(json: any): UpdateTimeEntryTypeRequest {
    return UpdateTimeEntryTypeRequestToJSONTyped(json, false);
}

export function UpdateTimeEntryTypeRequestToJSONTyped(value?: UpdateTimeEntryTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'isActive': value['isActive'],
        'description': value['description'],
        'useEmployeePayRate': value['useEmployeePayRate'],
        'useAppointmentPayRate': value['useAppointmentPayRate'],
        'percentage': BalanceUnitStatementEntryDebitToJSON(value['percentage']),
        'hourlyPayRate': BalanceUnitStatementEntryDebitToJSON(value['hourlyPayRate']),
        'roles': value['roles'],
    };
}

